module.exports = __webpack_public_path__ + "img/start_4.1b98dfb2.svg";